import React from 'react';
import { useCart } from '../../context/CartContext';

const CartItem = ({ item, isPaymentScreen = false }) => {
    const { updateQuantity, removeItem } = useCart();

    // Construir la URL de la imagen
    const getImageSrc = () => {
        if (item.image_base64) {
            return `data:image/jpeg;base64,${item.image_base64}`;
        }

        const productId = item.original_id || item.id.toString().split('-custom-')[0];

        if (productId) {
            return `http://localhost:9000/images/products/${productId}`;
        }

        return null;
    };

    const imageSrc = getImageSrc();
    const hasImage = imageSrc != null;

    // Función para mostrar atributos personalizados de forma legible
    const renderCustomAttributes = () => {
        if (!item.customDescription) return null;

        return (
            <div className="mt-1 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                <span className="font-medium">Personalizado:</span> {item.customDescription}
            </div>
        );
    };

    // Indicador visual para productos personalizados
    const isCustomized = item.customDescription && item.customDescription.trim().length > 0;

    return (
        <div
            className="p-4 border rounded-lg mb-2 border-[#A0AEC0] shadow-sm"
            style={{ backgroundColor: 'var(--card_color)' }}
        >

            {/* Fila superior: Imagen, nombre, variantes y precio */}
            <div className="flex items-start space-x-4">
                {/* Imagen del producto */}
                <div className="w-16 h-16 bg-[#E2E8F0] rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0">
                    {hasImage ? (
                        <img
                            src={imageSrc}
                            alt={item.name}
                            className="w-full h-full object-cover rounded-lg"
                            onError={(e) => {
                                console.error(`Error al cargar la imagen para ${item.name}. image_url: ${imageSrc}`);
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                            }}
                            onLoad={() => console.log(`Imagen cargada correctamente para ${item.name}`)}
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-[#718096] text-xs">
                            Sin imagen
                        </div>
                    )}
                    <div className="w-full h-full flex items-center justify-center text-[#718096] text-xs" style={{ display: 'none' }}>
                        Sin imagen
                    </div>
                </div>

                {/* Nombre, variantes y precio */}
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                        <h3 className="font-medium text-[#1A202C] line-clamp-2 flex-1">{item.name}</h3>
                        {/* 🔥 Badge para productos personalizados */}
                        {isCustomized && (
                            <span className="px-2 py-0.5 bg-green-100 text-green-600 text-xs rounded-full flex-shrink-0">
                                Personalizado
                            </span>
                        )}
                    </div>

                    {/* MEJORADO: Mostrar atributos personalizados con mejor formato */}
                    {renderCustomAttributes()}

                    <p className="text-lg font-semibold mt-1 text-[#1A202C]">${(item.price * item.quantity).toLocaleString()}</p>

                    {/* Mostrar precio unitario si es diferente del original */}
                    {isCustomized && (
                        <p className="text-sm text-[#718096]">
                            Precio unitario: ${item.price.toLocaleString()}
                        </p>
                    )}
                </div>
            </div>

            {/* Fila inferior: Controles de cantidad y eliminar */}
            <div className="flex justify-between items-center mt-2">
                <div className="flex items-center space-x-1">
                    <button
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                        className={`w-8 h-8 rounded-full border transition-colors duration-200 ${isPaymentScreen ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'
                            }`}
                        style={{
                            backgroundColor: isPaymentScreen ? '#CBD5E0' : 'var(--button_color)',
                            borderColor: isPaymentScreen ? '#CBD5E0' : 'var(--button_color)',
                            color: isPaymentScreen ? '#718096' : 'white',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0',
                            margin: '0',
                            lineHeight: '1'
                        }}
                        disabled={isPaymentScreen}
                    >
                        <span style={{ transform: 'translateY(-1.6px)', display: 'block' }}>−</span>
                    </button>
                    <span className="w-8 text-center text-[#1A202C]">{item.quantity}</span>
                    <button
                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                        className={`w-8 h-8 rounded-full border transition-colors duration-200 ${isPaymentScreen ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'
                            }`}
                        style={{
                            backgroundColor: isPaymentScreen ? '#CBD5E0' : 'var(--button_color)',
                            borderColor: isPaymentScreen ? '#CBD5E0' : 'var(--button_color)',
                            color: isPaymentScreen ? '#718096' : 'white',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0',
                            margin: '0',
                            lineHeight: '1'
                        }}
                        disabled={isPaymentScreen}
                    >
                        <span style={{ transform: 'translateY(-1.6px)', display: 'block' }}>+</span>
                    </button>
                </div>

                <button
                    onClick={() => removeItem(item.id)}
                    className={`px-3 py-1 rounded transition-colors duration-200 whitespace-nowrap ${isPaymentScreen ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80'
                        }`}
                    style={{
                        backgroundColor: isPaymentScreen ? '#CBD5E0' : '#D53F4F',
                        color: 'white'
                    }}
                    disabled={isPaymentScreen}
                >
                    Eliminar
                </button>
            </div>
        </div>
    );
};

export default CartItem;